import React, { Component } from 'react';
import { Link } from "react-router-dom";
import './Footer.css';
import Service from '../service/Service';
const service = new Service();
import Cookies from "js-cookie";
import withLocation from '../../withLocation'

// @ts-ignore
import { DFPSlotsProvider, AdSlot } from 'react-dfp';

// import { GPTProvider, GPTSlot } from "goopubtag";


class Footer extends Component {
    constructor(props) {
        super(props);
        this.isApp = false;
        if (props.location.search.includes('from=app')) {
            this.isApp = true;
        }
    }
    componentDidMount() {
    if (this.isApp) {
  if (__isBrowser__ && window.__AUTH_DATA__) {
    let token = window.__AUTH_DATA__?.authData?.app_ftk;
    console.log("token >>>>>>>>>>>>>>>>>", token);
    if (token) {
      this.setAppFTKCookie(token);
    }
  }

//   if (window.__AUTH_DATA__?.authData?.ftk &&  (!global.ftk || global.ftk === 'undefined')) {
//         global.ftk = window.__AUTH_DATA__?.authData?.ftk;
//       } else {
//         if (window.__AUTH_DATA__?.authData?.app_ftk != "") {
//           global.ftk = Cookies.get("app_ftk");
//         } else {
//           global.ftk = Cookies.get("app_ftk");
//           if (typeof global.ftk == "undefined") {
//             global.ftk = "";
//           }
//         }
//       }
}


        // Initialize AdPushup
        if (typeof window !== "undefined") {
            window.adpushup = window.adpushup || {};
            window.adpushup.que = window.adpushup.que || [];

            // Push the trigger after DOM is ready
            window.adpushup.que.push(() => {
            window.adpushup.triggerAd("ba08db67-6e50-4f0c-8ec7-005afc93554d");
            });
        }
    // var adpushup = window.adpushup = window.adpushup || {};
    // adpushup.que = adpushup.que || [];
    // adpushup.que.push(() => {
    //   adpushup.triggerAd("ba08db67-6e50-4f0c-8ec7-005afc93554d");
    // });
    }

    setAppFTKCookie(token) {
  if (!token) return;

  document.cookie =
    `app_ftk=${encodeURIComponent(token)};` +
    `path=/;` +
    `domain=.firstcry.com`;
}

    render() {
        if (this.props.location.pathname.includes('/amp/')) {
            const footer_container = {
                backgroundColor: "#222",
                color: "#eaeaea",
                overflow: "hidden",
                width: "100%",
            }
            const footer_fclogo_text_container = {
                margin: "0 auto",
                position: "relative",
                paddingTop: "54px",
                paddingBottom: "20px",
                textAlign: "center"
            }
            const parentinglogo = {
                width: "272px",
                margin: "0 auto 20px"
            }
            const a = {
                display: "block",
                textDecoration: "none",
                color: "#fff",
            }
            const footer_text_wrap = {
                fontSize: "16px",
                fontWeight: "300",
                fontFamily: "Roboto",
                width: "80%",
                margin: "0 auto",
                lineHeight: "20px"
            }
            const copyright_text = {
                backgroundColor: "#0d0d0d",
                color: "#ccc",
                fontSize: "12px",
                display: "block",
                lineHeight: "20px",
                padding: "8px 8px 8px 54px"
            }
            return (
                <div>
                    {!this.isApp &&
                        <footer className="footer_container" style={footer_container}>
                            <div className="footer_fclogo_text_container" style={footer_fclogo_text_container}>
                                <div className="dfpbannerimage" style={{ display: "none" }}>
                                    <div className="desktop-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                        <DFPSlotsProvider dfpNetworkId={84382175} >
                                            <div id="div-gpt-ad-1592983186204-0" style={{ width: '970px', height: '90px', overflow: 'hidden', margin: '0 auto' }}>
                                                <AdSlot
                                                    adUnit="parenting.com/parenting.com_allcustompages_footer_tools_baby_names_memories_desktop"
                                                    sizes={[[728, 90], [970, 90]]}
                                                />
                                            </div>
                                        </DFPSlotsProvider>
                                        {/* ///////////////////// */}
                                        {/* <GPTProvider networkId={84382175} debug={true}>
                                        <div id="div-gpt-ad-1592983186204-0" style={{ width: '970px', height: '90px', overflow: 'hidden', margin: '0 auto' }}>
                                            <GPTSlot
                                                slotId="banner-ad"
                                                adUnit="parenting.com/parenting.com_allcustompages_footer_tools_baby_names_memories_desktop"
                                                sizes={[[728, 90], [970, 90]]}
                                            />
                                        </div>
                                        </GPTProvider> */}
                                    </div>
                                    <div className="msite-ads-block" role="img" aria-label="Advertisement unit" tabIndex={0}>
                                        <DFPSlotsProvider dfpNetworkId={84382175} >
                                            <div id="div-gpt-ad-1592983219614-0" style={{ width: '320px', height: '250px', overflow: 'hidden', margin: '0 auto' }}>
                                                <AdSlot
                                                    adUnit="parenting.com/parenting.com_allcustompages_tools_baby_names_memories_footer_msite"
                                                    sizes={[[300, 250], [320, 100], [320, 50]]}
                                                />
                                            </div>
                                        </DFPSlotsProvider>
                                        {/* //////////////////////////// */}
                                        {/* <GPTProvider networkId={84382175} debug={true}>
                                        <div id="div-gpt-ad-1592983219614-0" style={{ width: '320px', height: '250px', overflow: 'hidden', margin: '0 auto' }}>
                                            <GPTSlot
                                                slotId="banner-ad"
                                                adUnit="parenting.com/parenting.com_allcustompages_tools_baby_names_memories_footer_msite"
                                                sizes={[[300, 250], [320, 100], [320, 50]]}
                                            />
                                        </div>
                                        </GPTProvider> */}
                                    </div>
                                </div>
                                <div className="parenting_image_container">
                                    <a href={service.getRedirectUrl("/")} style={a}>
                                        <amp-img layout="responsive" height="90" width="272" src="https://cdn.cdnparenting.com/articles/2019/07/09173019/logo-header-mobile.png" alt="Parenting Firstcry" title="Parenting Firstcry" class="loadingImg" style={parentinglogo}></amp-img>
                                    </a>
                                    <div className="footer-text-wrap" style={footer_text_wrap}>The information on this website is of a general nature and available for educational purposes only and should not be construed as a substitute for advice from a medical professional or health care provider.  Should you have any concerns about your health, or of that of your baby or child, please consult with your doctor. You also acknowledge that owing to the limited nature of communication possible on interactive elements on the site, any assistance, or response you receive is provided by the author alone. Parenting.Firstcry.com accepts no liability for any errors, omissions or misrepresentations. Your use of this site indicates your agreement to be bound by the Terms of Use.</div>
                                    <div className="footer-social-wrap"></div>
                                </div>
                            </div>
                            <div className="copyright_text_container">
                                <div className="td-pb-span td-sub-footer-menu"></div>
                                <div className="copyright_text" style={copyright_text}>
                                    © 2010-{new Date().getFullYear()} www.FirstCry.com. All rights reserved. This website can be best viewed in resolution width of 1024 and above.
                                </div>
                            </div>
                        </footer>
                    }
                </div>
            )
        }
        else {
            return (
                <div>
                    {!this.isApp &&
                        <footer className="footer_container">
                            <div className="footer_fclogo_text_container">
                                <div className="parenting_image_container">
                                    <a href={service.getRedirectUrl("/")}>
                                        <img src="https://cdn.cdnparenting.com/articles/2019/07/09173019/logo-header-mobile.png" alt="Parenting Firstcry" title="Parenting Firstcry" className="" width="272" height="90" />
                                    </a>
                                    <div className="footer-text-wrap">The information on this website is of a general nature and available for educational purposes only and should not be construed as a substitute for advice from a medical professional or health care provider.  Should you have any concerns about your health, or of that of your baby or child, please consult with your doctor. You also acknowledge that owing to the limited nature of communication possible on interactive elements on the site, any assistance, or response you receive is provided by the author alone. Parenting.Firstcry.com accepts no liability for any errors, omissions or misrepresentations. Your use of this site indicates your agreement to be bound by the Terms of Use.</div>
                                    <div className="footer-social-wrap td-social-style-2">
                                        <span className="td-social-icon-wrap">
                                            <a target="_blank" rel="nofollow,noreferrer" href="https://www.facebook.com/FirstCryParenting/" title="Facebook">
                                                <span className="footer_icons footer_facebook" data-icon-font="J"></span>
                                            </a>
                                        </span>
                                        <span className="td-social-icon-wrap">
                                            <a target="_blank" rel="nofollow,noreferrer" href="https://www.instagram.com/firstcryparenting/" title="Instagram">
                                                <span className="footer_icons footer_instagram" data-icon-font="&#xe031;"></span>
                                            </a>
                                        </span>
                                        <span className="td-social-icon-wrap">
                                            <a target="_blank" rel="nofollow,noreferrer" href="https://www.youtube.com/firstcryparenting" title="Youtube">
                                                <span className="footer_icons footer_youtube" data-icon-font="&#xe036;"></span>
                                            </a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="copyright_text_container">
                                <div className="td-pb-span td-sub-footer-menu"></div>
                                <div className="copyright_text">
                                    <div className="td-sub-footer-container td-container-wrap ">
                                        <div className="td-container">
                                            <div className="td-pb-row">
                                                <div className="td-pb-span td-sub-footer-menu">
                                                    <div className="menu-td-demo-footer-menu-container">
                                                        <ul id="menu-td-demo-footer-menu" className="td-subfooter-menu">
                                                            <li id="menu-item" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-first td-menu-item td-normal-menu menu-item">
                                                                <a href="https://parenting.firstcry.com/cookie-privacy-policy/">Privacy Policy</a>
                                                            </li>
                                                            <li id="menu-item" className="menu-item menu-item-type-custom menu-item-object-custom td-menu-item td-normal-menu menu-item">
                                                                <a href="https://parenting.firstcry.com/terms-of-use/">Terms of Use</a>
                                                            </li>
                                                            <li id="menu-item" className="menu-item menu-item-type-custom menu-item-object-custom td-menu-item td-normal-menu menu-item">
                                                                <a href="https://parenting.firstcry.com/editorial-policy/">Editorial Policy</a>
                                                            </li>
                                                            <li id="menu-item" className="menu-item menu-item-type-custom menu-item-object-custom td-menu-item td-normal-menu menu-item">
                                                                <a href="https://parenting.firstcry.com/content-image-usage-policy/">Content &amp; Image Usage Policy</a>
                                                            </li>
                                                            <li id="menu-item" className="menu-item menu-item-type-custom menu-item-object-custom td-menu-item td-normal-menu menu-item">
                                                                <a href="https://parenting.firstcry.com/advertise-with-us/">Advertise with Us</a>
                                                            </li>
                                                            <li id="menu-item" className="menu-item menu-item-type-custom menu-item-object-custom td-menu-item td-normal-menu menu-item">
                                                                <a href="https://parenting.firstcry.com/about-us/">About Us</a>
                                                            </li>
                                                            <li id="menu-item" className="menu-item menu-item-type-custom menu-item-object-custom td-menu-item td-normal-menu menu-item">
                                                                <a href="https://parenting.firstcry.com/contact/">Contact Us</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="td-pb-span td-sub-footer-copy">
                                                    © 2010-{new Date().getFullYear()} Parenting.FirstCry.com. All rights reserved.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div>© 2010-{new Date().getFullYear()} www.FirstCry.com. All rights reserved. This website can be best viewed in resolution width of 1024 and above.</div> */}
                                </div>
                            </div>
                        </footer>
                    }
                </div>
            )
        }
    }
}
export default withLocation(Footer);
